module.exports = __webpack_public_path__ + "img/ad-support-lg.05fcbd76.jpg";